import { render, staticRenderFns } from "./retur-set-price-action.vue?vue&type=template&id=798b135f&"
import script from "./retur-set-price-action.vue?vue&type=script&lang=js&"
export * from "./retur-set-price-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports